import { Typography, Divider, Stack, Skeleton } from '@mui/material';
import React, { useEffect, useState, memo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import Box from '@mui/material/Box';
import { environment } from '../../../environments/environment';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { useTranslation } from 'react-i18next';
import FeesDialog from '../Dialouge/FeesDailoge';
import ReusableDialog from '../Dialouge/ReusableDailoge';

const BillDetails = ({
  type = 'pickup',
  data,
  total,
  addressStore,
  store,
  dataStore,
  deliveryFee,
  backendTax,
  displayTotal,
  displaySubtotal,
  displayModifiersPrice,
  totalDiscounts,
  isCalculatingPrice = false,
  displayDeliveryFee, // Add store data prop for delivery fees
  storeData,
  taxesText = null,
  displayOnlineFee,
}) => {
  const cart = useSelector((state) => state.shopReducer.cart, shallowEqual);

  const { code, discount, isVerify } = useSelector(
    (state) => state.shopReducer.cartData,
    shallowEqual
  );

  const [open, setOpen] = React.useState(false);
  const [opentaxes, setOpentaxes] = React.useState(false);
  const [openDeliveryFees, setOpenDeliveryFees] = React.useState(false);
  const [dataSet, setDataSet] = useState(data);
  const [address, setAddress] = useState(addressStore);
  const [storee, setStore] = useState(store);

  useEffect(() => {
    setDataSet(data);
    setAddress(addressStore);
  }, [addressStore, data]);
  useEffect(() => {
    setStore(store);
  }, [store, dataStore, data]);

  const handleClose = () => {
    setOpen(false);
  };
  const [t, i18n] = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        padding: '0px 12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
      dir={i18n.language === 'ar' || i18n.language === 'he' ? 'rtl' : 'ltr'}
    >
      {environment.restaurantId !== 'fattyPattyDev' &&
        environment.restaurantId !== 'fattyPatty' && (
          <Divider style={{ border: '3px solid #C4C4C4' }} />
        )}
      {!!cart && !!cart.length && cart.length > 0 && (
        <>
          {' '}
          <Box
            sx={{
              width: '100%',
              padding: '12px 2%',
            }}
          >
            {' '}
            <Typography
              component="a"
              variant="body1"
              sx={{
                fontFamily: '"Jost", sans-serif',
                color: '#1A1A1A',
                fontWeight: 600,
                fontSize: '16px',
                display: 'flex',
              }}
            >
              Cart Total
            </Typography>
          </Box>
          {/* <Divider /> */}
          <div
            style={{
              flexDirection: 'row',
              display: 'flex',
              justifyContent: 'space-between',
              padding: '0px 2%',
            }}
          >
            <Typography
              component="a"
              variant="body1"
              sx={{
                fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                display: 'flex',

                color: '#4D4D4D',
              }}
            >
              {t('basket.subtotal')}:
            </Typography>

            {isCalculatingPrice ? (
              <Skeleton
                variant="text"
                width={80}
                height={24}
                sx={{
                  backgroundColor: '#f0f0f0',
                  '&::after': {
                    background: `linear-gradient(90deg, transparent, ${environment.mainColor}20, transparent)`,
                  },
                }}
              />
            ) : (
              <Typography
                component="a"
                variant="body1"
                sx={{
                  fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                  display: 'flex',
                }}
              >
                {environment.currency}
                {isVerify && code !== '' ? (
                  <>
                    <span>
                      {displaySubtotal ||
                        (() => {
                          const discountedTotal =
                            (total || 0) - (discount || 0);
                          const value = parseFloat(
                            discountedTotal.toString().replaceAll(',', '')
                          );
                          return !isNaN(value) ? value.toFixed(2) : '0.00';
                        })()}
                    </span>
                    <br />
                    <span
                      style={{
                        textDecoration: 'line-through',
                        color: '#4D4D4D',
                        marginLeft: '5px',
                      }}
                    >
                      {environment.currency}
                      {displaySubtotal ||
                        (() => {
                          const value = parseFloat(
                            (total || 0).toString().replaceAll(',', '')
                          );
                          return !isNaN(value) ? value.toFixed(2) : '0.00';
                        })()}
                    </span>
                  </>
                ) : (
                  displaySubtotal ||
                  (() => {
                    const value = parseFloat(
                      (total || 0).toString().replaceAll(',', '')
                    );
                    return !isNaN(value) ? value.toFixed(2) : '0.00';
                  })()
                )}
                <br />
              </Typography>
            )}
          </div>
          {/* Modifiers Price Display */}
          {displayModifiersPrice && parseFloat(displayModifiersPrice) > 0 && (
            <div
              style={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 2%',
              }}
            >
              <Typography
                component="a"
                variant="body1"
                sx={{
                  fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                  display: 'flex',
                  color: '#4D4D4D',
                }}
              >
                Customizations:
              </Typography>

              {isCalculatingPrice ? (
                <Skeleton
                  variant="text"
                  width={80}
                  height={24}
                  sx={{
                    backgroundColor: '#f0f0f0',
                    '&::after': {
                      background: `linear-gradient(90deg, transparent, ${environment.mainColor}20, transparent)`,
                    },
                  }}
                />
              ) : (
                <Typography
                  component="a"
                  variant="body1"
                  sx={{
                    fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                    display: 'flex',
                  }}
                >
                  {environment.currency}
                  {displayModifiersPrice}
                </Typography>
              )}
            </div>
          )}
          {type === 'delivery' && (
            <div
              style={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 2%',
              }}
            >
              <Stack direction="row" spacing={0.5} alignItems="center">
                <Typography
                  component="a"
                  variant="body1"
                  sx={{
                    fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                    display: 'flex',
                    color: '#4D4D4D',
                  }}
                >
                  {t('basket.deliveryFees')}{' '}
                </Typography>
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{
                    cursor: 'pointer',
                  }}
                  style={{ direction: 'initial' }}
                  onClick={() => setOpenDeliveryFees(true)}
                />
              </Stack>

              {isCalculatingPrice ? (
                <Skeleton
                  variant="text"
                  width={60}
                  height={24}
                  sx={{
                    backgroundColor: '#f0f0f0',
                    '&::after': {
                      background: `linear-gradient(90deg, transparent, ${environment.mainColor}20, transparent)`,
                    },
                  }}
                />
              ) : (
                <Typography
                  component="a"
                  variant="body1"
                  sx={{
                    fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                    display: 'flex',
                  }}
                >
                  {environment.currency}
                  {displayDeliveryFee || 0}
                </Typography>
              )}
            </div>
          )}
          <div
            style={{
              flexDirection: 'row',
              display: 'flex',
              justifyContent: 'space-between',
              padding: '0px 2%',
            }}
          >
            <Typography
              component="a"
              variant="body1"
              sx={{
                fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                color: '#4D4D4D',
              }}
            >
              {/* not the dialog */}
              <span
                title={taxesText || ''}
                style={{
                  display: 'inline-block',
                  maxWidth: 180,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  verticalAlign: 'middle',
                }}
              >
                Estimated Taxes:
              </span>

              <InfoOutlinedIcon
                fontSize="small"
                sx={{
                  cursor: 'pointer',
                }}
                style={{ direction: 'initial' }}
                onClick={() => setOpentaxes(true)}
              />
            </Typography>

            {isCalculatingPrice ? (
              <Skeleton
                variant="text"
                width={60}
                height={24}
                sx={{
                  backgroundColor: '#f0f0f0',
                  '&::after': {
                    background: `linear-gradient(90deg, transparent, ${environment.mainColor}20, transparent)`,
                  },
                }}
              />
            ) : (
              <Typography
                component="a"
                variant="body1"
                sx={{
                  fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                  display: 'flex',
                }}
                style={{ direction: 'initial' }}
              >
                <FeesDialog
                  opentaxes={opentaxes}
                  setOpentaxes={setOpentaxes}
                  orderType={type}
                  backendTax={backendTax}
                  taxesText={taxesText}
                  dialogType="tax"
                />

                {/* Delivery Fees Dialog */}
                {type === 'delivery' && (
                  <FeesDialog
                    opentaxes={openDeliveryFees}
                    setOpentaxes={setOpenDeliveryFees}
                    orderType={type}
                    dialogType="delivery"
                    storeData={storeData}
                  />
                )}

                {/* finish dialog */}
                {type === 'dinein' && (
                  <p>
                    {dataStore?.businessName === storee ? (
                      <p>
                        {' '}
                        {environment.currency}
                        {(() => {
                          const tax = parseFloat((backendTax || 0).toString());
                          return isNaN(tax) ? '0.00' : tax.toFixed(2);
                        })()}{' '}
                      </p>
                    ) : (
                      ''
                    )}
                  </p>
                )}
                {type === 'delivery' && (
                  <p>
                    {dataSet?.id === address ? (
                      <p>
                        {environment.currency}{' '}
                        {(() => {
                          const tax = parseFloat((backendTax || 0).toString());
                          return isNaN(tax) ? '0.00' : tax.toFixed(2);
                        })()}
                      </p>
                    ) : (
                      ''
                    )}
                  </p>
                )}

                {type === 'pickup' && (
                  <p>
                    {dataStore?.businessName === storee ? (
                      <p>
                        {environment.currency}{' '}
                        {(() => {
                          const tax = parseFloat((backendTax || 0).toString());
                          return isNaN(tax) ? '0.00' : tax.toFixed(2);
                        })()}{' '}
                      </p>
                    ) : (
                      ''
                    )}
                  </p>
                )}
              </Typography>
            )}
          </div>
          {displayOnlineFee && parseFloat(displayOnlineFee) > 0 && (
            <div
              style={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 2%',
              }}
            >
              <Typography
                component="a"
                variant="body1"
                sx={{
                  fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                  display: 'flex',
                  color: '#4D4D4D',
                  textTransform: 'capitalize',
                }}
              >
                online ordering fee:
              </Typography>

              {isCalculatingPrice ? (
                <Skeleton
                  variant="text"
                  width={80}
                  height={24}
                  sx={{
                    backgroundColor: '#f0f0f0',
                    '&::after': {
                      background: `linear-gradient(90deg, transparent, ${environment.mainColor}20, transparent)`,
                    },
                  }}
                />
              ) : (
                <Typography
                  component="a"
                  variant="body1"
                  sx={{
                    fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                    display: 'flex',
                  }}
                >
                  {environment.currency}
                  {displayOnlineFee || 0}
                </Typography>
              )}
            </div>
          )}
          {/* Total Discounts Section */}
          {totalDiscounts && parseFloat(totalDiscounts) > 0 && (
            <div
              style={{
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0px 2%',
              }}
            >
              <Typography
                component="a"
                variant="body1"
                sx={{
                  fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                  display: 'flex',
                  color: '#EA4B48',
                }}
              >
                Total Discounts:
              </Typography>

              {isCalculatingPrice ? (
                <Skeleton
                  variant="text"
                  width={60}
                  height={24}
                  sx={{
                    backgroundColor: '#f0f0f0',
                    '&::after': {
                      background: `linear-gradient(90deg, transparent, ${environment.mainColor}20, transparent)`,
                    },
                  }}
                />
              ) : (
                <Typography
                  component="a"
                  variant="body1"
                  sx={{
                    fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                    display: 'flex',
                    color: '#EA4B48',
                  }}
                >
                  -{environment.currency}
                  {(() => {
                    const discountValue = parseFloat(
                      (totalDiscounts || 0).toString()
                    );
                    return isNaN(discountValue)
                      ? '0.00'
                      : discountValue.toFixed(2);
                  })()}
                </Typography>
              )}
            </div>
          )}
          <Divider />
          <div
            style={{
              flexDirection: 'row',
              display: 'flex',
              justifyContent: 'space-between',
              padding: '0px 2%',
            }}
          >
            <Typography
              component="a"
              variant="body1"
              sx={{
                fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                display: 'flex',
                color: environment.mainColor,
                fontWeight: 'bold',
              }}
            >
              {t('basket.total')}
            </Typography>
            {isCalculatingPrice ? (
              <Skeleton
                variant="text"
                width={100}
                height={28}
                sx={{
                  backgroundColor: '#f0f0f0',
                  '&::after': {
                    background: `linear-gradient(90deg, transparent, ${environment.mainColor}20, transparent)`,
                  },
                }}
              />
            ) : (
              <Typography
                component="a"
                variant="body1"
                sx={{
                  fontFamily: '"Jost", "Helvetica", "Arial", sans-serif',
                  display: 'flex',
                  color: environment.mainColor,
                  fontWeight: 'bold',
                }}
              >
                {type === 'pickup' && (
                  <div>
                    <p>
                      {dataStore?.businessName === store ? (
                        <p>
                          {' '}
                          {environment.currency}
                          {displayTotal ||
                            (() => {
                              const sub = isVerify
                                ? total - (discount || 0)
                                : total;
                              const tax = parseFloat(
                                (backendTax || 0).toString()
                              );
                              const sum =
                                (isNaN(sub) ? 0 : sub) + (isNaN(tax) ? 0 : tax);
                              return sum.toFixed(2);
                            })()}{' '}
                        </p>
                      ) : (
                        ''
                      )}
                    </p>{' '}
                  </div>
                )}
                {type === 'dinein' && (
                  <div>
                    <p>
                      {dataStore?.businessName === storee ? (
                        <p>
                          {environment.currency}
                          {displayTotal ||
                            (() => {
                              const sub = isVerify
                                ? total - (discount || 0)
                                : total;
                              const tax = parseFloat(
                                (backendTax || 0).toString()
                              );
                              const sum =
                                (isNaN(sub) ? 0 : sub) + (isNaN(tax) ? 0 : tax);
                              return sum.toFixed(2);
                            })()}{' '}
                        </p>
                      ) : (
                        ''
                      )}
                    </p>{' '}
                  </div>
                )}
                {type === 'delivery' && (
                  <div>
                    <p>
                      {dataSet?.id === address ? (
                        <p>
                          {' '}
                          {environment.currency}
                          {displayTotal ||
                            (() => {
                              const sub = isVerify
                                ? total - (discount || 0)
                                : total;
                              const tax = parseFloat(
                                (backendTax || 0).toString()
                              );
                              const delFee = isNaN(deliveryFee)
                                ? 0
                                : parseFloat(deliveryFee);
                              const sum =
                                (isNaN(sub) ? 0 : sub) +
                                (isNaN(tax) ? 0 : tax) +
                                delFee;
                              return sum.toFixed(2);
                            })()}
                        </p>
                      ) : (
                        ''
                      )}
                    </p>{' '}
                  </div>
                )}
              </Typography>
            )}
          </div>
        </>
      )}

      <ReusableDialog
        open={open}
        onClose={handleClose}
        title={t('basket.deliveryFees')}
        description={t(
          'basket.deliveryFeesAreCalculatedBasedOnYourLocationAndOtherFactors'
        )}
        buttonText={t('basket.oK')}
      />
    </Box>
  );
};

// Custom comparison to prevent unnecessary re-renders
const arePropsEqual = (prevProps, nextProps) => {
  return (
    prevProps.type === nextProps.type &&
    prevProps.displayTotal === nextProps.displayTotal &&
    prevProps.displaySubtotal === nextProps.displaySubtotal &&
    prevProps.displayModifiersPrice === nextProps.displayModifiersPrice &&
    prevProps.displayDeliveryFee === nextProps.displayDeliveryFee &&
    prevProps.totalDiscounts === nextProps.totalDiscounts &&
    prevProps.backendTax === nextProps.backendTax &&
    prevProps.displayOnlineFee === nextProps.displayOnlineFee &&
    prevProps.isCalculatingPrice === nextProps.isCalculatingPrice &&
    prevProps.taxesText === nextProps.taxesText
  );
};

export default memo(BillDetails, arePropsEqual);
